import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { studentSidebarData } from '../../../core/common/data/json/student-sidebar'
import { all_routes } from '../../router/all_routes'
import { useAuth } from '../../../provider/AuthProvider'

const StudentSidebar = () => {
  const location = useLocation()
  const { logout } = useAuth()
  const [showLogoutModal, setShowLogoutModal] = useState(false)
  return (
    <div className="col-lg-3 ">
      <div className="settings-sidebar theiaStickySidebar">
        <div>
          <h6 className="mb-3">Main Menu</h6>
          <ul className="mb-3 pb-1">
            {studentSidebarData.map((menu: any, index: any) => (
              <li key={index}>
                <Link
                  to={menu.route}
                  className={`d-inline-flex align-items-center ${
                    `${location.pathname}${location.search}` === menu.route ||
                    `${location.pathname}${location.search}` === menu.subRoute ||
                    (!location.search &&
                      location.pathname === menu.route) ||
                    (!location.search &&
                      location.pathname === menu.subRoute)
                      ? 'active'
                      : ''
                  }`}
                >
                  <i className={`${menu.icon} me-2`} />
                  {menu.title}
                </Link>
              </li>
            ))}
          </ul>
          <hr />
          <h6 className="mb-3">Account Settings</h6>
          <ul>
            <li>
              <Link
                to={all_routes.studentSettings}
                className={`d-inline-flex align-items-center ${
                  location.pathname.includes('settings') ? 'active' : ''
                }`}
              >
                <i className="isax isax-setting-25 me-2" />
                Settings
              </Link>
            </li>
            <li>
              <div
                onClick={() => setShowLogoutModal(true)}
                className="d-inline-flex align-items-center"
                style={{ cursor: 'pointer' }}
              >
                <i className="isax isax-logout5 me-2" />
                Logout
              </div>
            </li>
          </ul>
        </div>
      </div>
      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div
          className="modal fade show"
          style={{ display: 'block', background: 'rgba(0,0,0,0.5)' }}
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <h5 className="mb-3">Confirm Logout</h5>
                  <p className="mb-3">Are you sure you want to logout?</p>
                  <div className="d-flex align-items-center justify-content-center">
                    <button
                      className="btn btn-light me-2"
                      onClick={() => setShowLogoutModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setShowLogoutModal(false)
                        logout()
                      }}
                    >
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default StudentSidebar
